import { POSType } from '../interfaces/POS';

// The POS types a combi deal never goes on: the Subscription and Prepaid online shops sell no F&B. Mirrors the
// backend's CombiDealSales.ExcludedPosTypes (PAUL-2861).
export const COMBI_DEAL_EXCLUDED_POS_TYPES: POSType[] = [POSType.Subscription, POSType.PrepaidOnline];
